import React, { Component } from 'react';
import { FormControl } from 'react-bootstrap';
import { $Formutil, connect } from 'react-bootstrap-formutil';
import Alert from 'components/base/Alert';
import FormGroup from 'components/FormGroup';
import FormSelect from 'components/FormSelect';
import SelectFormutil from 'components/Formutil/SelectFormutil';
import { Fade } from 'components/Transition';
import type { FormCheckNumberType, FormCheckType } from 'types/common';
import { JobTypeEnum } from 'types/customer';
import config from 'utils/config';
import { getShowAdditionalSourceIncome, getShowCompany, incomeTypesOptions, jobInfoOptions } from './helper';

export interface JobInfoFormutilType {
    job: JobTypeEnum;
    employer_confirm?: string;
    additional_source_income?: string;
    temporary_regulatory_members_checked?: FormCheckType;
    questionnaire_answer?: any;
    is_professional?: FormCheckNumberType; // 0 非专业 1 专业
    company: string;
}

export interface IJobInfoProps {
    $formutil: $Formutil<JobInfoFormutilType>;
    label?: React.ReactNode;
    disabled?: boolean;
    country?: string;
}

class JobInfo extends Component<IJobInfoProps> {
    static defaultProps = {
        label: '',
        disabled: false
    };

    validMessage = {
        employer: {
            required: config.inputAError(__('employer'), true),
            isEmployer: __('The employer you entered is not valid')
        }
    };

    $validators = {
        isEmployer: (value, prop, { validMessage: { isEmployer } }) => {
            if (/^[a-zA-Z\d\s\-/:;()$&@.,?![\]{}#%^*+=_\\|~<>]+$/g.test(value)) {
                return true;
            }

            return isEmployer;
        },
        modifyErrorCheck: () => true
    };

    public render() {
        const { disabled, $formutil } = this.props;
        const { job } = $formutil.$params;
        const jobModifyErrorCheck = $formutil.$errors.job?.modifyErrorCheck;
        const incomeModifyErrorCheck = $formutil.$errors.additional_source_income?.modifyErrorCheck;
        const companyModifyErrorCheck = $formutil.$errors.company?.modifyErrorCheck;

        return (
            <div className="jobinfo-root">
                <h3 className="open-title mt-0">{__('EMPLOYMENT INFORMATION')}</h3>
                <SelectFormutil
                    name="job"
                    label={__('Employment Status')}
                    $defaultValue={JobTypeEnum.Employed}
                    required={!disabled}
                    $validators={{ modifyErrorCheck: () => true }}
                    errorLevel={jobModifyErrorCheck ? 'off' : undefined}
                    modifyErrorCheck
                    validMessage={{ required: config.inputError(__('employment status')) }}
                    selectProps={{
                        options: jobInfoOptions,
                        placeholder: __('Please Select'),
                        disabled
                    }}
                />
                {jobModifyErrorCheck && <Alert variant="danger">{jobModifyErrorCheck}</Alert>}
                <Fade in={getShowAdditionalSourceIncome(job)} exit={false}>
                    <div>
                        <FormGroup
                            label={__('Source of Income')}
                            name="additional_source_income"
                            required={!disabled}
                            $validators={{ modifyErrorCheck: () => true }}
                            errorLevel={incomeModifyErrorCheck ? 'off' : undefined}
                            modifyErrorCheck
                            validMessage={{
                                required: __('Please fill the source of income')
                            }}>
                            <FormSelect
                                placeholder={__('Please Select')}
                                disabled={disabled}
                                options={incomeTypesOptions}
                            />
                        </FormGroup>
                        {incomeModifyErrorCheck && <Alert variant="danger">{incomeModifyErrorCheck}</Alert>}
                    </div>
                </Fade>
                {/* 受雇和自主创业需要提供单位信息 */}
                <Fade in={getShowCompany(job)} exit={false}>
                    <div className="companyinfo-container">
                        <FormGroup
                            label={__("Employer's Name")}
                            name="company"
                            required={!disabled}
                            isEmployer
                            errorLevel={companyModifyErrorCheck ? 'off' : undefined}
                            modifyErrorCheck
                            $validators={this.$validators}
                            validMessage={this.validMessage.employer}>
                            <FormControl disabled={disabled} placeholder={__("Employer's Name")} />
                        </FormGroup>
                        {companyModifyErrorCheck && <Alert variant="danger">{companyModifyErrorCheck}</Alert>}
                    </div>
                </Fade>
            </div>
        );
    }
}

export default connect(JobInfo);
export * from './helper';
